import React, { Suspense, useEffect } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'

import Spinner from '@divvy-web/skylab.spinner'

import { getEmailFromStorage, getEmailHashFromStorage } from '@sputnik/auth'
import { SputnikCanaryProvider } from '@sputnik/canary/SputnikCanaryProvider'

export interface WithExperimentParams {
  experiment: string
  inputId: string
  bucketingKey?: string
}

// children must re-render with fresh props, so identify runs in an effect instead of memoizing the provider
export const LocalExperimentProvider = ({
  children,
  experiment,
  inputId,
}: React.PropsWithChildren<WithExperimentParams>) => {
  const ldClient = useLDClient()

  useEffect(() => {
    const emailHash = getEmailHashFromStorage() ?? 'anonymous-user'
    const userEmail = getEmailFromStorage() ?? ''

    ldClient
      ?.identify({
        kind: 'multi',
        creditApplicant: {
          key: emailHash,
          email: userEmail,
          _meta: {
            privateAttributes: ['/email'],
          },
        },
        [experiment]: {
          key: inputId,
        },
      })
      // failures fall back to default flag values, same as before
      .catch(() => {})
  }, [ldClient, experiment, inputId])

  return <SputnikCanaryProvider>{children}</SputnikCanaryProvider>
}

export default (props: React.PropsWithChildren<WithExperimentParams>) => (
  <Suspense fallback={<Spinner />}>
    <LocalExperimentProvider {...props} />
  </Suspense>
)
